import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { environment } from "./environments/environment";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";

// Import and initialize loader configuration early
import "./app/shared/config/loader.config";

// Set global loaders.gl configuration to suppress deprecated warnings
if (typeof globalThis !== "undefined") {
  // Set global options for loaders.gl to use the new mvt.shape option
  (globalThis as any)._loadersgl = {
    ...((globalThis as any)._loadersgl || {}),
    MVTLoader: {
      mvt: {
        shape: "geojson",
      },
    },
  };
}

// Configure console to suppress specific warnings
if (typeof globalThis !== "undefined" && globalThis.console) {
  const originalWarn = globalThis.console.warn;
  globalThis.console.warn = (...args: any[]) => {
    // Suppress specific loaders.gl deprecated warnings and Mapbox featureNamespace warnings
    if (
      args[0] &&
      typeof args[0] === "string" &&
      (args[0].includes('loaders.gl: MVTLoader: "options.gis" is deprecated') ||
        args[0].includes('MVTLoader: "options.gis" is deprecated') ||
        (args[0].includes("featureNamespace") && args[0].includes("place-labels")) ||
        args[0].includes("selector is not associated to the same source"))
    ) {
      return; // Suppress these specific warnings
    }
    originalWarn.apply(globalThis.console, args);
  };
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));

// Register Service Worker
if ("serviceWorker" in navigator && !environment.local) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/ngsw-worker.js", { scope: "/" })
      .then(registration => {
        console.debug("Service Worker registered with scope:", registration.scope);
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker) {
            installingWorker.onstatechange = () => {
              if (installingWorker?.state === "installed") {
                if (navigator.serviceWorker.controller) {
                  console.info("New content is available; please refresh.");
                } else {
                  console.debug("Content is cached for offline use.");
                }
              }
            };
          }
        };
      })
      .catch(error => {
        console.error("Service Worker registration failed:", error);
      });
  });
}
